import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import styles from './LangModal.module.scss';

const LangModal = ({
  isOpen,
  onClose,
  children,
  modalBodyClassname,
  dialogClassName,
  blurry,
  topBottomBehaviour,
}) => {
  const nodeRef = useRef(null);

  const handleEnter = () => {
    document.body.style.overflow = 'hidden';
    window.isHoveringCalendar = true;
  };

  const handleExited = () => {
    document.body.style.overflow = 'auto';
    window.isHoveringCalendar = false;
  };

  return ReactDOM.createPortal(
    <>
      {isOpen && (
        <div
          className={`${styles['modal-overlay']} ${blurry ? styles['blurry'] : ''}`}
          onClick={onClose}
        />
      )}

      <CSSTransition
        nodeRef={nodeRef}
        in={isOpen}
        timeout={200}
        classNames={
          topBottomBehaviour
            ? {
                enter: styles['slide-bottom-enter'],
                enterActive: styles['slide-bottom-enter-active'],
                exit: styles['slide-bottom-exit'],
                exitActive: styles['slide-bottom-exit-active'],
              }
            : {
                enter: styles['fade-enter'],
                enterActive: styles['fade-enter-active'],
                exit: styles['fade-exit'],
                exitActive: styles['fade-exit-active'],
              }
        }
        unmountOnExit
        onEnter={handleEnter}
        onExited={handleExited}
      >
        <div
          ref={nodeRef}
          className={styles['modal-wrapper']}
          onClick={onClose}
        >
          <div
            className={`${styles['modal-content']} ${dialogClassName ?? ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={`${styles['modal-body']} ${modalBodyClassname ?? ''}`}
            >
              {children}
            </div>
          </div>
        </div>
      </CSSTransition>
    </>,
    document.body
  );
};

export default LangModal;
